<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="费用单" v-if="findChildren(143)!==-1" name="costorder" style="height: 100%;">
				<costorder-index />
			</el-tab-pane>
			<el-tab-pane label="形式费用单" v-if="findChildren(152)!==-1" name="formalcostorder" style="height: 100%;">
				<formalcostorder-index />
			</el-tab-pane>			
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import costorderIndex from './costorder/index.vue'
	import formalcostorderIndex from './formalcostorder/index.vue'

	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			costorderIndex,
			formalcostorderIndex
		}
	}
</script>